import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './plan-category.reducer';

export const PlanCategoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const planCategoryEntity = useAppSelector(state => state.planCategory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="planCategoryDetailsHeading">
          <Translate contentKey="fitengineerBackendV2App.planCategory.detail.title">PlanCategory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{planCategoryEntity.id}</dd>
          <dt>
            <span id="planCategory">
              <Translate contentKey="fitengineerBackendV2App.planCategory.planCategory">Plan Category</Translate>
            </span>
          </dt>
          <dd>{planCategoryEntity.planCategory}</dd>
        </dl>
        <Button tag={Link} to="/plan-category" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/plan-category/${planCategoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PlanCategoryDetail;
